import React from 'react';

interface IconProps {
  color?: string;
}

function Icon({ color = '#0044F0' }: IconProps): JSX.Element {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40">
      <path
        stroke={color}
        strokeWidth="2"
        d="M8 1h24a7 7 0 0 1 7 7v24a7 7 0 0 1-7 7H8a7 7 0 0 1-7-7V8a7 7 0 0 1 7-7Z"
      ></path>
      <path
        fill={color}
        d="M32.833 12a1.19 1.19 0 0 1 .974.515q.079.117.125.247l.017.046q.01.035.018.07.032.128.033.265V20c0 .631-.522 1.143-1.167 1.143A1.155 1.155 0 0 1 31.667 20v-4.098l-9.092 8.906a1.184 1.184 0 0 1-1.65 0l-5.008-4.906-7.926 7.763a1.184 1.184 0 0 1-1.65 0 1.126 1.126 0 0 1 0-1.616l8.75-8.571.09-.078a1.184 1.184 0 0 1 1.56.078l5.009 4.906 8.267-8.098h-4.184a1.155 1.155 0 0 1-1.166-1.143c0-.631.522-1.143 1.166-1.143z"
      ></path>
    </svg>
  );
}

export default Icon;
